<form
    *ngIf="slot"
    [formGroup]="formGroup"
    (submit)="applyPromoCode(formGroup.controls['promoCode'].value, true)"
>
    <div class="row" *ngIf="!discountData && config.params.promoCodesEnabled">
        <div class="col-7">
            <mlp-ng-input-tooltip
                formControlName="promoCode"
                placeholder="Discount Code"
                inputId="promoCode"
                [tooltipTemplate]="discountTooltip"
                [errors]="errors()"
            ></mlp-ng-input-tooltip>
        </div>

        <div class="col-5">
            <mlp-ng-button
                class="d-flex form-button"
                label="Apply"
                fullWidth="1"
                btnStyle="tertiary"
                (click)="
                    applyPromoCode(formGroup.controls['promoCode'].value, true)
                "
            ></mlp-ng-button>
        </div>
    </div>
</form>

<div *ngIf="slot && discountData && !isFree()" class="row mt-0">
    <div class="col-8 pt-0 pb-2 d-flex align-items-center discount">
        <a (click)="removeDiscount()" class="cursor font-weight-bold">
            <mlp-ng-icon name="bin" class="sg-color -danger"></mlp-ng-icon>
        </a>

        <div class="pl-2 w-100">
            Discount <strong>"{{ discountData.code }}"</strong> applied!

            <div class="discount-value d-block small">
                {{
                    discountData.discountType == "percentage"
                        ? discountData.discountValue + "%"
                        : (discountData.discountValue
                          | currency: slot.attributes.currency)
                }}
                off
            </div>
        </div>
    </div>

    <div
        class="col-4 py-2 d-flex align-items-center justify-content-end discount"
    >
        <span *ngIf="discountData && discountData.discountType == 'fix-amount'">
            -{{
                slot.attributes.price - discountData.discountPrice
                    | currency: slot.attributes.currency
            }}
        </span>

        <span *ngIf="discountData && discountData.discountType == 'percentage'">
            -{{
                slot.attributes.price - discountData.discountPrice
                    | currency: slot.attributes.currency
            }}
        </span>
    </div>
</div>

<div
    *ngIf="slot && !isFree()"
    class="row px-3 sg-color"
    [class.mt-2]="discountData"
    [class.mt-4]="!discountData"
>
    <div class="col-6 px-0 py-3 total">
        <strong>Total:</strong>
    </div>

    <div class="col-6 px-0 py-3 text-right total">
        <strong>
            <span *ngIf="isFree()">Free</span>
            <span *ngIf="!isFree()">
                {{ getTotal() | currency: slot.attributes.currency }}</span
            >
        </strong>
    </div>
</div>

<ng-template #discountTooltip>
    <p class="text-left mb-0 small">
        Enter a valid code to receive a discount on your booking. All discount
        codes are subject to terms and conditions.
    </p>
</ng-template>
